import { render, staticRenderFns } from "./sign_up.vue?vue&type=template&id=5c2e04e0&lang=pug"
import script from "./sign_up.js?vue&type=script&lang=js&external"
export * from "./sign_up.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports